export const portfolio = [
  {
    id: 1,
    slug: 'fintech-dashboard',
    title: "FinTech Dashboard",
    category: "Web App",
    description: "A comprehensive dashboard for a financial institution with real-time data visualization.",
    longDescription: "A comprehensive dashboard for a financial institution with real-time data visualization, KPI tracking, and secure reporting workflows.",
    clientName: "Finance Corp",
    websiteUrl: "https://demo.raadsotech.com",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop",
    galleryImages: [
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop"
    ],
    detailFields: [
      { label: "Deliverables", value: "Product Dashboard", type: "text" },
      { label: "Live URL", value: "https://demo.raadsotech.com", type: "url" },
    ],
    year: "2025",
    industry: "Financial Technology",
    direction: "Product Dashboard"
  },
  {
    id: 2,
    slug: 'e-commerce-platform',
    title: "E-Commerce Platform",
    category: "E-Commerce",
    description: "A modern e-commerce solution with seamless payment integration and inventory management.",
    longDescription: "A modern e-commerce solution with seamless payment integration, inventory management, and admin analytics.",
    clientName: "Retail Group",
    websiteUrl: "https://shop.raadsotech.com",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=800&auto=format&fit=crop",
    galleryImages: [
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=800&auto=format&fit=crop"
    ],
    detailFields: [
      { label: "Platform Scope", value: "Storefront + Admin Panel", type: "text" },
      { label: "Store URL", value: "https://shop.raadsotech.com", type: "url" },
    ],
    year: "2024",
    industry: "Retail & Commerce",
    direction: "Platform Development"
  },
  {
    id: 3,
    slug: 'healthcare-portal',
    title: "Healthcare Portal",
    category: "Web Portal",
    description: "A secure patient portal for healthcare providers with appointment booking and telemedicine capabilities.",
    longDescription: "A secure patient portal for healthcare providers with appointment booking, medical records access, and telemedicine capabilities.",
    clientName: "MedCare Clinic",
    image: "/img/Healthcare Portal.jpg",
    galleryImages: ["/img/Healthcare Portal.jpg"],
    detailFields: [
      { label: "Portal Modules", value: "Appointments, Records, Telemedicine", type: "text" },
    ],
    year: "2025",
    industry: "Healthcare",
    direction: "Portal Experience"
  },
  {
    id: 4,
    slug: 'smart-home-app',
    title: "Smart Home App",
    category: "Mobile App",
    description: "An intuitive mobile application to control and monitor smart home devices globally.",
    longDescription: "An intuitive mobile application to control and monitor smart home devices globally with automation rules and alerts.",
    clientName: "Smart Living Co",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?q=80&w=800&auto=format&fit=crop",
    galleryImages: [
      "https://images.unsplash.com/photo-1558002038-1055907df827?q=80&w=800&auto=format&fit=crop"
    ],
    detailFields: [
      { label: "App Platforms", value: "iOS and Android", type: "text" },
    ],
    year: "2023",
    industry: "IoT & Smart Living",
    direction: "Mobile Experience"
  }
];
